import React, { useState } from 'react'
import { ActivityIndicator, View } from 'react-native'
import { StackScreenProps } from '@react-navigation/stack'
import { AppNavigatorParams } from '../../../navigation/types'
import { useTranslation } from 'react-i18next'
import NodeMemberSearch from './components/node-member.search'
import { NodeMemberList } from './components/node-member.list'
import { useNodeByIdQuery } from '../../../generated/graphql'

type Props = StackScreenProps<AppNavigatorParams, 'NodeMembers'>

export const NodeMembersScreen: React.FC<Props> = ({ route }) => {
  const { nodeId } = route.params
  const { t } = useTranslation('nodes')

  const { data: nodeData } = useNodeByIdQuery({
    variables: { id: nodeId },
  })

  const node = nodeData?.nodeById
  const [searchMode, setSearchMode] = useState<'filter' | 'search'>('filter')

  if (!node) {
    return (
      <View
        style={{
          flex: 1,
          padding: 16,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ActivityIndicator accessibilityLabel={t('loading')} />
      </View>
    )
  }

  return (
    <View style={{ flex: 1, padding: 16 }}>
      {searchMode === 'search' ? (
        <NodeMemberSearch
          node={node}
          onUpdate={() => {}}
          onSwitchMode={() => setSearchMode('filter')}
        />
      ) : (
        <NodeMemberList
          node={node}
          onUpdate={() => {}}
          onSwitchMode={() => setSearchMode('search')}
        />
      )}
    </View>
  )
}

export default NodeMembersScreen
